<template>
  <div v-if="!isPhoneBool && !collapsed" class="d-flex pl-2">
    <component v-for="button in buttonlist" :key="button" :is="button" :small="true">
    </component>
  </div>
</template>


<script>
import ActionMenu from "@/components/Buttons/ActionMenu.vue";
import ApproveJobBtn from "@/components/Buttons/ApproveJobBtn.vue";
import ArticlePickerBtn from "@/components/Buttons/ArticlePickerBtn.vue";
import CancelNewJobBtn from "@/components/Buttons/CancelNewJobBtn.vue";
import CompleteJobBtn from "@/components/Buttons/CompleteJobBtn.vue";
import CopyJobBtn from "@/components/Buttons/CopyJobBtn.vue";
import CreateJobBtn from "@/components/Buttons/CreateJobBtn.vue";
import DeleteJobBtn from "@/components/Buttons/DeleteJobBtn.vue";
import HazardAnalysisBtn from "@/components/Buttons/HazardAnalysisBtn.vue";
import ImportMachineBtn from "@/components/Buttons/ImportMachineBtn.vue";
import NewAccountBtn from "@/components/Buttons/NewAccountBtn.vue";
import NewAppointmentBtn from "@/components/Buttons/NewAppointmentBtn.vue";
import NewAssetTypeBtn from "@/components/Buttons/NewAssetTypeBtn.vue";
import NewCustomerBtn from "@/components/Buttons/NewCustomerBtn.vue";
import NewCustomerGroupBtn from "@/components/Buttons/NewCustomerGroupBtn.vue";
import NewDialogTriggerBtn from "@/components/Buttons/NewDialogTriggerBtn.vue";
import NewEntityBtn from "@/components/Buttons/NewEntityBtn.vue";
import NewJobBtn from "@/components/Buttons/NewJobBtn.vue";
import NewLeadBtn from "@/components/Buttons/NewLeadBtn.vue";
import NewLeadTypeBtn from "@/components/Buttons/NewLeadTypeBtn.vue";
import NewLoggBtn from "@/components/Buttons/NewLoggBtn.vue";
import NewSupplierBtn from "@/components/Buttons/NewSupplierBtn.vue";
import NewSupplierFailureCodeBtn from "@/components/Buttons/NewSupplierFailureCodeBtn.vue";
import NonAlfaBtn from "@/components/Buttons/NonAlfaBtn.vue";
import OldPageNewEntityBtn from "@/components/Buttons/OldPageNewEntityBtn.vue";
import ServiceReportBtn from "@/components/Buttons/ServiceReportBtn.vue";
import ToggleCustomerActiveBtn from "@/components/Buttons/ToggleCustomerActiveBtn.vue";
import ToggleJobCategoryActiveBtn from "@/components/Buttons/ToggleJobCategoryActiveBtn.vue";
import ToggleMachineActiveBtn from "@/components/Buttons/ToggleMachineActiveBtn.vue";
import TogglePublicViewBtn from "@/components/Buttons/TogglePublicViewBtn.vue";
import TransferAllMachinesBtn from "@/components/Buttons/TransferAllMachinesBtn.vue";
import UploadFileBtn from "@/components/Buttons/UploadFileBtn.vue";
import NavMixin from "@/helpers/Mixins/NavMixin.js";
//import PlannerComponentController from "@/components/Buttons/PlannerComponentController.vue";

export default {
  name: "HeaderBtns",
  props: {
    collapsed: Boolean,
  },
  components: {
    ActionMenu,
    ApproveJobBtn,
    CompleteJobBtn,
    CancelNewJobBtn,
    CopyJobBtn,
    CreateJobBtn,
    DeleteJobBtn,
    HazardAnalysisBtn,
    NewEntityBtn,
    NewAppointmentBtn,
    NewCustomerGroupBtn,
    NewSupplierBtn,
    NewJobBtn,
    NewCustomerBtn,
    NewAccountBtn,
    NewLoggBtn,
    NewDialogTriggerBtn,
    NewAssetTypeBtn,
    NewLeadBtn,
    NewLeadTypeBtn,
    NewSupplierFailureCodeBtn,
    NonAlfaBtn,
    ServiceReportBtn,
    UploadFileBtn,
    ImportMachineBtn,
    ToggleMachineActiveBtn,
    ToggleCustomerActiveBtn,
    TogglePublicViewBtn,
    OldPageNewEntityBtn,
    TransferAllMachinesBtn,
    ToggleJobCategoryActiveBtn,
    ArticlePickerBtn,
  },
  mixins: [NavMixin],

  data() {
    return {

    };
  },

  mounted() {
  },

  methods: {
  },

  computed: {
    buttonlist() {
      return this.$route?.meta?.overrides?.header?.buttons ?? [];
    },
  },

  watch: {
  },
};
</script>


<style lang="scss"></style>